import type {FormatCurrencyNotation} from 'src/public/formatCurrency/types';
import type {Notation} from 'src/public/formatNumber/types';

export default function resolveFinalNotation(
  forceCompactNotationAbove: number | undefined,
  value: number,
  userNotation: FormatCurrencyNotation | Notation | undefined,
) {
  if (
    typeof forceCompactNotationAbove !== 'undefined' &&
    Math.abs(value) > Math.abs(forceCompactNotationAbove)
  ) {
    return 'compact';
  }
  return userNotation;
}
